module.exports = __webpack_public_path__ + "img/language-cn.32ac72a9.jpg";